import './KbContentDiff.css'
import { diffLines } from 'diff'
import { cn } from '@/utilities/misc'

type Props = {
  oldText: string
  newText: string
  className?: string
}

export function KbContentDiff({ oldText, newText, className }: Props) {
  const changes = diffLines(oldText, newText)
  const hasChanges = changes.some(c => c.added || c.removed)

  if (!hasChanges) {
    return (
      <div className={cn('KbContentDiff', 'Empty', className)}>
        No differences
      </div>
    )
  }

  return (
    <pre className={cn('KbContentDiff', className)}>
      {changes.map((part, i) => {
        if (part.added) {
          return (
            <span key={i} className='Added'>
              {part.value}
            </span>
          )
        }
        if (part.removed) {
          return (
            <span key={i} className='Removed'>
              {part.value}
            </span>
          )
        }
        return (
          <span key={i} className='Unchanged'>
            {part.value}
          </span>
        )
      })}
    </pre>
  )
}
